import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './product.scss';
import securityService from '../security/security.service';
import productService from './product.service';
import saleInvoiceService from '../sale-invoice/sale-invoice.service';

import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';

const ProductAdd = (props) => {
  console.log(props)
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

  const [inputProps, setInputProps] = useState({
    ProductID: { name: 'ProductID', value: props.ProductID || undefined },
    
    ProductDescription1: {
      name: { id: 'ProductDescription1ID', value: 'ProductDescription1' },
      caption:  securityService.getCaptionForDescriptionInputs('ProductDescription1') ||  'Description 1',
      value: { id: props.ProductDescription1ID || 0, value:  props.ProductDescription1 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription1' },
      isControlBlur: false
    },

    ProductDescription2: {
      name: { id: 'ProductDescription2ID', value: 'ProductDescription2' },
      caption:  securityService.getCaptionForDescriptionInputs('ProductDescription2') ||  'Description 2',
      value: { id: props.ProductDescription2ID || 0, value:  props.ProductDescription2 ||'' },
      dataSource: { type: 'Route', route: 'ProductDescription2' },
      isControlBlur: false
    },

    ProductDescription3: {
      name: { id: 'ProductDescription3ID', value: 'ProductDescription3' },
      caption:  securityService.getCaptionForDescriptionInputs('ProductDescription3') ||  'Description 3',
      value: { id: props.ProductDescription3ID || 0, value:  props.ProductDescription3 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription3' },
      isControlBlur: false
    },

    ProductDescription4: {
      name: { id: 'ProductDescription4ID', value: 'ProductDescription4' },
      caption:  securityService.getCaptionForDescriptionInputs('ProductDescription4') ||  'Description 4',
      value: { id: props.ProductDescription4ID || 0, value:  props.ProductDescription4 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription4' },
      isControlBlur: false
    },

    ProductDescription5: {
      name: { id: 'ProductDescription5ID', value: 'ProductDescription5' },
      caption:  securityService.getCaptionForDescriptionInputs('ProductDescription5') ||  'Description 5',
      value: { id: props.ProductDescription5ID || 0, value:  props.ProductDescription5 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription5' },
      isControlBlur: false
    },

    ProductDescription6: {
      name: { id: 'ProductDescription6ID', value: 'ProductDescription6' },
      caption:  securityService.getCaptionForDescriptionInputs('ProductDescription6') ||  'Description 6',
      value: { id: props.ProductDescription6ID || 0, value:  props.ProductDescription6  || '' },
      dataSource: { type: 'Route', route: 'ProductDescription6' },
      isControlBlur: false
    },

    ProductName: {
      name: 'ProductName',
      value: props.ProductName || '',
      caption: 'Article Name',
      enabled: true
    },

    GDID: {
      name: { id: 'GDID', value: 'GDID' },
      caption: 'GD',
      value: { id: props.GDID || null, value:  props.GDNo ||  '' },
      dataSource: { type: 'Route', route: 'GD' },
      isControlBlur: false
    },

    hsCode: {
      name: { id: 'hsCodeID', value: 'hsCode' },
      caption: 'HS Code',
      value: { id: props.hS_CODE || null, value: '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    },

    uoM: {
      name: { id: 'uoMID', value: 'uoM' },
      caption: 'Unit of Measurement',
      value: { id:null , value:props.uoM || '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    },

    OpeningQuantity: {
      name: 'OpeningQuantity',
      value: props.OpeningQuantity || 0.00,
      caption: 'Opening Quantity',
      decimal: 2
    },

    OpeningRate: {
      name: 'OpeningRate',
      value: props.OpeningRate || 0.00,
      caption: 'Opening Rate',
      decimal: 2
    },

    TaxPercent: {
      name: 'TaxPercent',
      value: props.TaxPercent || 0.00,
      caption: 'Tax %',
      decimal: 2
    }
  });


  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = { ...updatedValues[key], ...valueObj[key] };
        }
      });
      return updatedValues;
    });
  };

  // Load all dropdown sources
  useEffect(() => {
    if(props.isAdd == false){
      getUOMDataSource(props.hS_CODE)
    }
    loadHSCodeSource();
  }, []);

 
  

  const loadHSCodeSource = async () => {
    try {
      const CompanyID = securityService.getCompanyIDLoggedInUserId();
      const response = await saleInvoiceService.getItemDescCode(CompanyID);
      if (response?.data) {
        console.log(response?.data)
        const hsCodeData = response.data.map((row) => ({
          id: row.hS_CODE,
          value: `${row.hS_CODE} | ${row.description}`
        }));
        updateMainSecionsValue({
          hsCode: { dataSource: { type: 'Data', data: hsCodeData || [] } }
        });

        setTimeout(()=>{
        
        if(props.isAdd == false){
          
    console.log(hsCodeData.filter(e => e.id == props.hS_CODE)[0].value || '')
          updateMainSecionsValue({
            hsCode:{value: {id: props.hS_CODE ,
            value: hsCodeData.filter(e => e.id == props.hS_CODE)[0].value || ''}},
          });
          document.getElementById('hsCode').value = hsCodeData.filter(e => e.id == props.hS_CODE)[0].value || '';
        }
        },600)
        }
    } catch (error) {
      console.error('Error loading HS Code source:', error);
    }
  };

  const getUOMDataSource = async (
    hsCodeValue = inputProps.hsCode.value.id
  ) => {
    try {
      const CompanyID = securityService.getCompanyIDLoggedInUserId();
      const data = {
        CompanyID,
        hs_code: hsCodeValue,
        annexure_id: 3
      };

      if (data.hs_code) {
        const response = await saleInvoiceService.getUOMDDSource(data);
        console.log(response?.data)
        if (response?.data) {
          const uoMDataSource = response.data.map((row) => ({
            id: row.uoM_ID,
            value: row.description
          }));
          updateMainSecionsValue({
            uoM: {
              dataSource: { type: 'Data', data: uoMDataSource || [] }
            }
          });

          setTimeout(()=>{
        
            if(props.isAdd == false){
        console.log(uoMDataSource.filter(e => e.value == props.uoM)[0].value || '')
              updateMainSecionsValue({
                hsCode:{value: {id: props.uoM ,
                value: props.uoM}},
              });
              // document.getElementById('uoM').value = uoMDataSource.filter(e => e.id == props.uoM)[0].value || '';
            }
            },600)
        }
      }
    } catch (error) {
      console.error('Error loading UOM source:', error);
    }
  };

  // Generate ProductName from descriptions
  const generateProductName = (updatedInputs) => {
    const parts = [
      updatedInputs.ProductDescription1?.value?.value,
      updatedInputs.ProductDescription2?.value?.value,
      updatedInputs.ProductDescription3?.value?.value,
      updatedInputs.ProductDescription4?.value?.value,
      updatedInputs.ProductDescription5?.value?.value,
      updatedInputs.ProductDescription6?.value?.value
    ].filter(Boolean);

    return parts.join('-');
  };

  const handleInputChange = (value, name) => {
    const updatedInputs = { ...inputProps };

    if (name.includes('ProductDescription') || name === 'ProductName') {
      updatedInputs[name] = { 
        ...inputProps[name], 
        value: name === 'ProductName' ? inputProps[name].value : value 
      };

      // Auto-generate ProductName
      const newProductName = generateProductName(updatedInputs);
      updatedInputs.ProductName = {
        ...inputProps.ProductName,
        value: newProductName
      };
    } else if (name === 'hsCode') {
      updatedInputs[name] = { 
        ...inputProps[name], 
        value: value 
      };
      getUOMDataSource(value.id);
    } else {
      updatedInputs[name] = { 
        ...inputProps[name], 
        value: value 
      };
    }

    setInputProps(updatedInputs);
  };

  const inputsList = [
    { Input: HiddenComponent, Props: { ...inputProps.ProductID, setInputProps }, ColumnSize: 0 },
    
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription1, setInputProps, onChange: handleInputChange }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription2, setInputProps, onChange: handleInputChange }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription3, setInputProps, onChange: handleInputChange }, ColumnSize: 4 },
    
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription4, setInputProps, onChange: handleInputChange }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription5, setInputProps, onChange: handleInputChange }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription6, setInputProps, onChange: handleInputChange }, ColumnSize: 4 },

    { Input: TextComponent, Props: { ...inputProps.ProductName, setInputProps }, ColumnSize: 12 },

    { Input: DropdownComponent, Props: { ...inputProps.GDID, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.hsCode, setInputProps, onChange: handleInputChange }, ColumnSize: 6 },

    { Input: DropdownComponent, Props: { ...inputProps.uoM, setInputProps }, ColumnSize: 4 },
    { Input: NumberComponent, Props: { ...inputProps.OpeningQuantity, setInputProps }, ColumnSize: 4 },
    { Input: NumberComponent, Props: { ...inputProps.OpeningRate, setInputProps }, ColumnSize: 4 },

    { Input: NumberComponent, Props: { ...inputProps.TaxPercent, setInputProps }, ColumnSize: 6 }
  ];

  return (
    <div>
      <StructuredGenerate 
        mainProps={props} 
        title={`${props.Title} ${props.isAdd === true ? ` - Add` : ` - Edit`}`} 
        Inputs={inputsList} 
      />
    </div>
  );
};

export default ProductAdd;